import $x from '@/utils/$x';

/**
 + * 列表
 + * @param {*} params
 + * @returns
 + */
export async function getActionForbidModelList(params) {
  return $x.post(`/actionForbid/list`, params);
}

/**
 * 新增
 * @param {*} params
 * @returns
 */
export function addActionForbidModel(params) {
  return $x.post('/actionForbid/add', params);
}

/**
 * 更新
 * @param {*} params
 * @returns
 */
export function updateActionForbidModel(params) {
  return $x.post('/actionForbid/modify', params);
}

/**
 * delete
 * @param {*} params
 * @returns
 */
export function deleteActionForbidModel(params) {
  return $x.post('/actionForbid/operate', params);
}

/**
 * findOne
 * @param {*} params
 * @returns
 */
export function getActionForbidModelById(params) {
  return $x.post('/pergamonGoods/queryPhysicalGoodsById', params);
}
